import { apiGet, apiPatch } from './client';
import type { Rate, RateBatchRequest } from '../types/Rate';

export function getRates(): Promise<Rate[]> {
  return apiGet<Rate[]>('/api/rates');
}

export function saveRatesBatch(
  added: Rate[],
  modified: Rate[],
  deletedIds: number[],
): Promise<Rate[]> {
  return apiPatch<RateBatchRequest, Rate[]>('/api/rates/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
